import React, {useCallback, useEffect, useState} from 'react';
import {size} from "../../../../models/size";
import {ApiQueryParam, ApiService} from "../../../../service/ApiService";
import {sizeResultCollectionType, sizeResultType} from "../../../../types/Api/SizeResultType";
import {sizeHydrator} from "../../../../models/hydrator/sizeHydrator";
import {Loader} from "../../../../components/admin/Loader";
import {SizeSortable} from "../../../../components/admin/equipment/SizeSortable";
import {NavLink, useNavigate} from "react-router-dom";
import {scrollTo} from "../../../../service/ToolsService";

export const Order = () => {
  const navigate = useNavigate();

  const [size, setSize] = useState([] as size[]);
  const [loading, setLoading] = useState(false);

  const findSize = useCallback((): void => {
    const apiFilters: ApiQueryParam = new ApiQueryParam();

    apiFilters.addSort({
      by: 'order',
      direction: 'ASC'
    });
    apiFilters.setCount(-1);

    setLoading(true);
    const result: Promise<sizeResultCollectionType> = ApiService.get('/size', apiFilters) as Promise<sizeResultCollectionType>;

    result
      .then((r: sizeResultCollectionType) => {
        setSize(r._embedded.sizes.map((size: sizeResultType) => {
            return sizeHydrator.hydrate(size);
          })
        );
      })
      .catch(() => {
        alert("Une erreur c'est produite.")
        setSize([]);
      })
      .finally(() => {
        setLoading(false);
      })
  }, []);

  useEffect(() => {
    findSize();
  }, [findSize]);

  const onSave = async (size: size[]) => {
    const p = size.map((n: size, i: number) => {
      if (n.order !== i) {
        return ApiService.patch(`/size/${n.sizeId}`, { param: () => {return {order: i}} })
      }

      return Promise<void>;
    });

    await Promise.all(p);

    navigate('/admin/equipment/size');
  }

  return (
    <>
      {loading && (
        <Loader/>
      )}
      {!loading && (
        <>
          <div className="d-flex align-content-between">
            <SizeSortable size={size}/>
          </div>
          <div className="mt-2">
            <button type="button" className="btn btn-sm btn-success me-1" onClick={() => onSave(size)}>Enregistrer</button>
            <NavLink to={`/admin/equipment/size`} onClick={scrollTo} className="btn btn-sm btn-info">Retour aux tailles</NavLink>
          </div>
        </>
      )}
    </>
  );
}
